import { useEffect, useState } from "react";
import api from "../api";

const EUR = (n) => "€ " + Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 0 });
const MESI = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

export const WonHistory = () => {
  const [data, setData] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    api.get(`/pipeline/won-history?year=${year}`).then((r) => setData(r.data)).catch(() => {});
  }, [year]);

  if (!data) return null;
  const max = Math.max(...data.months.map((m) => m.amount), 1);
  const anyCount = data.total_count > 0;

  return (
    <div className="panel" data-testid="won-history-panel">
      <div className="toolbar" style={{ marginBottom: 4 }}>
        <h3 style={{ margin: 0 }}>📈 Storico chiusure {data.year}</h3>
        <span className="muted" style={{ marginLeft: 10, fontSize: 13 }}>
          {data.total_count} lead diventati clienti · valore portato {EUR(data.total_amount)}
        </span>
        <div className="spacer" />
        <button className="btn xs" onClick={() => setYear(year - 1)} data-testid="won-history-prev">←</button>
        <span style={{ margin: "0 8px", fontWeight: 700 }}>{year}</span>
        <button className="btn xs" onClick={() => setYear(year + 1)} disabled={year >= new Date().getFullYear()} data-testid="won-history-next">→</button>
      </div>
      {!anyCount ? (
        <p className="empty" style={{ margin: "8px 0 0" }}>Nessun lead chiuso come cliente nel {year}. Quando segni un lead "Diventato cliente" (con 💶 importi) comparirà qui.</p>
      ) : (
        <div style={{ display: "flex", alignItems: "flex-end", gap: 6, height: 150, marginTop: 12 }} data-testid="won-history-chart">
          {data.months.map((m) => (
            <div key={m.month} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 4, minWidth: 0 }}
              title={m.count ? `${MESI[m.month - 1]}: ${m.count} chiusi · ${EUR(m.amount)}\n${m.names.join(", ")}` : `${MESI[m.month - 1]}: nessuna chiusura`}
              data-testid={`won-month-${m.month}`}>
              <span style={{ fontSize: 11, fontWeight: 700, color: m.amount > 0 ? "var(--green)" : "transparent" }}>{m.amount > 0 ? EUR(m.amount) : "·"}</span>
              <div style={{
                width: "70%", borderRadius: "6px 6px 2px 2px",
                height: Math.max(m.amount > 0 ? 8 : 2, Math.round(m.amount / max * 100)),
                background: m.amount > 0 ? "var(--grad, linear-gradient(180deg,#34d399,#0ea5e9))" : "rgba(255,255,255,.12)",
                transition: "height .3s",
              }} />
              <span style={{ fontSize: 11.5 }} className="muted">{MESI[m.month - 1]}</span>
              <span style={{ fontSize: 11, fontWeight: 700 }}>{m.count > 0 ? `${m.count} 🎯` : ""}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
